require('./bootstrap');

import loadingButton from './components/LoadingButton.vue';
import Panel from "./components/ui/Panel";

new Vue({
    el: '#app',
    i18n,
    data: {
        currentStep: 0,
        error: "",
        user: {
            email: "",
            name: "",
            image: "",
            inbox: ""
        },
        supportEmail: window.supportEmail || "support@attacksimulator.com",
    },
    components: {
        Panel
    },
    methods: {
        focusElement(element) {
            if (!this.$refs[element]) {
                setTimeout(() => {
                    document.querySelector('input:not([type="hidden"])')?.focus();
                }, 300);
            } else {
                setTimeout(() => {
                    this.$refs[element].focus();
                }, 300);
            }
        },
        actions(target) {
            switch (target) {
                case 'checkEmail':
                    this.checkEmail();
                    break;
                case 'emailPassword':
                    this.emailPassword();
                    break;
                case 'requestAccount':
                    this.requestAccount();
                    break;
            }
        },
        checkEmail(e) {
            if (e instanceof KeyboardEvent || e instanceof MouseEvent) {
                this.loading = true;
                axios.post('/auth/checkEmail', {email: this.user.email})
                    .then(response => {
                        this.user = response.data;
                        this.currentStep = 1;
                        this.error = "";
                        this.focusElement('password');
                        application.resetFormBlock();
                    }).catch(error => {
                    this.focusElement('email');
                    console.log(error);
                    if (error.response) {
                        // The request was made, but the server responded with a status code
                        // that falls out of the range of 2xx
                        this.error = error.response.data.errors.email[0];
                        application.resetFormBlock();
                    }
                    application.resetFormBlock();
                });
            }

            if (e) {
                e.preventDefault();
            }
            return false;
        },
        emailPassword(e) {
            this.loading = true;
            axios.post('/forgot-password', {email: this.user.email})
                .then(response => {
                    this.currentStep = 1;
                    this.error = "";
                    this.$set(this.user, 'inbox', response.data.url);
                    application.resetFormBlock();
                }).catch(error => {
                if (error.response) {
                    // The request was made, but the server responded with a status code
                    // that falls out of the range of 2xx
                    this.focusElement('email');
                    this.error = error.response.data.errors.email[0];
                }
                application.resetFormBlock();
            });
            if (e) {
                e.preventDefault();
            }
            return false;
        },
        requestAccount(e) {
            axios.post('/register', $("form#registrationForm").serialize()).then(response => {
                this.currentStep = 1;
                this.error = "";
                this.$set(this.user, 'inbox', response.data.url);
            }).catch(error => {
                if (error.response) {
                    const errors = Object.values(error.response.data.errors);
                    alert(errors.join("\n"));
                }
            });

            if (e) {
                e.preventDefault();
            }
            return false;
        }
    },
    computed: {
        supportEmailLink() {
            return `mailto:${this.supportEmail}`;
        }
    },
    created() {
        this.$on('clicked', this.actions);
    },
    beforeDestroy() {
        this.$off('clicked', this.actions);
    },
    mounted() {
        if (typeof error !== "undefined") {
            this.error = error;
        }
        this.focusElement('email');
    }
});

